import type { LanguageProperty } from 'ehs-react';
import { createStore, showError } from 'ehs-react';
import { checkAccess } from './ajax';

interface AccessState {
  blocked?: boolean;
  errorLanguageKey: LanguageProperty;
  loading: boolean;
}

type AccessStore = AccessState & {
  checkAccess: (
    url: string,
    accessCode: string,
    pin: string,
    isProfessional: boolean
  ) => void;
};

const initialState: AccessState = {
  blocked: false,
  loading: false,
  errorLanguageKey: 'checkaccessportlet.error.message'
};

export const [useAccessStore, AccessStoreApi] = createStore<AccessStore>(
  'CAP::access.store',
  set => ({
    ...initialState,

    checkAccess(url, accessCode, pin, isProfessional) {
      set({ blocked: false });
      checkAccess({
        accessInformation: {
          accessCode,
          pin,
          professional: isProfessional
        },
        setLoading: loading => set({ loading }),
        url
      })
        .then(response => {
          if (response.success) {
            const {
              success,
              redirectUrl,
              blocked,
              statusTranslation
            } = response.data;

            if (!success) {
              set({
                blocked: blocked ?? false,
                errorLanguageKey:
                  (statusTranslation as LanguageProperty) ??
                  'checkaccessportlet.error.message'
              });
            }
            if (typeof redirectUrl === 'string') {
              window.location.href = redirectUrl;
            }
          }
        })
        .catch(showError);
    }
  })
);
